import { render, staticRenderFns } from "./question_list.vue?vue&type=template&id=2a5da9d2&scoped=true&"
import script from "./question_list.vue?vue&type=script&lang=js&"
export * from "./question_list.vue?vue&type=script&lang=js&"
import style0 from "./question_list.vue?vue&type=style&index=0&id=2a5da9d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5da9d2",
  null
  
)

export default component.exports